export const environment = {
  production: true,
  API: 'https://api.xrleiloes.com.br',
  UPLOADS_DIR: 'https://api.xrleiloes.com.br/uploads',
  SOCKET_URL: 'https://panel.xrleiloes.com.br/',
  FRONTEND_URL: 'https://xrleiloes.com.br',
};
